import { getIcon } from '@monash/portal-frontend-common';
import c from './preview-link-card.module.scss';
import { Card, fontStyles } from '@monash/portal-react';
import classNames from 'classnames';
import { useWatch } from 'react-hook-form';

const PreviewLinkCard = () => {
  const [name, description, icon] = useWatch({
    name: ['name', 'description', 'icon'],
  });

  const isEmpty = !icon && !name && !description;

  return (
    <Card className={c.card}>
      {isEmpty ? (
        <>
          <div className={classNames(c.skeleton, c.icon)} />
          <div className={classNames(c.skeleton, c.name)} />
          <div className={classNames(c.skeleton, c.desc)} />
        </>
      ) : (
        <>
          <div>{getIcon(icon)}</div>
          <h3 className={classNames(fontStyles.heading, fontStyles.sm)}>
            {name}
          </h3>
          <p className={classNames(fontStyles.body, c.description)}>
            {description}
          </p>
        </>
      )}
    </Card>
  );
};

export default PreviewLinkCard;
